import { Injectable } from '@angular/core';
import { SessionsService } from '../modules/sessions/sessions.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRouteSnapshot, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { merge } from 'ramda/es';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
declare const jQuery: any;

@Injectable()
export class Topbar {
  public term: string = '';
  public title: Observable<string>;
  public searching = new BehaviorSubject<boolean>(false);
  public searching$ = this.searching.asObservable();

  constructor(private sessions: SessionsService, private router: Router) {
    this.title = this.router.events
      .filter(event => event instanceof NavigationEnd)
      .map(() => this.nestedTitle(this.router.routerState.snapshot.root));
  }

  public setTerm(val) {
    if (val.length > 0 && !jQuery('ng-component').hasClass('active')) {
      jQuery('ng-component, search').addClass('active');
    }
    if (val.length === 0 && jQuery('ng-component').hasClass('active')) {
      jQuery('ng-component, search').removeClass('active');
    }
    this.searching.next(val.length > 0);
    this.term = val.toLowerCase();
  }

  private nestedTitle(routeSnapshot: ActivatedRouteSnapshot) {
    let title: string = routeSnapshot.data ? routeSnapshot.data['title'] : '';
    if (routeSnapshot.firstChild) {
      title = this.nestedTitle(routeSnapshot.firstChild) || title;
    }
    if (title && title[0] === '$') {
      const substr = title.substring(1);
      if (routeSnapshot.data['data'] && substr in routeSnapshot.data['data']) {
        title = routeSnapshot.data['data'][substr];
      }
    }
    return title;
  }

  getData() {
    return Observable.combineLatest(
      this.getSessions().map(sessions => ({ data: sessions, name: 'Sessions' }))
      // Add more search provider here
    );
  }

  getSessions() {
    return this.sessions
      .getAll()
      .map(data => data.filter(info => info.name.toLowerCase().indexOf(this.term) >= 0))
      .map(data => data.map(session => merge(session, { searchLink: `/sessions/${session.id}` })));
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/topbar.ts